<template>
    <div>
        <!-- <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>标签技能配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->

        <el-tabs class="mytab" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="标签配置" name="labelconfig"></el-tab-pane>
            <el-tab-pane label="技能配置" name="skillconfig"></el-tab-pane>
        </el-tabs>

        <!-- 标签 -->
        <div   v-if="activeName=='labelconfig'">
            <el-card shadow="hover">
                <!-- 搜索 -->
                <el-form :inline="true" size="small" v-model="listQuery">

                    <el-form-item label="课程名称">
                        <el-input v-model="listQuery.labelName" placeholder="" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="addLabelClick" class="el-icon-plus" plan>新增标签</el-button>
                    </el-form-item>

                </el-form>

                <!-- 列表数据 -->
                <el-table :data="listData" border style="width: 100%" class="table">
                    <el-table-column type="index" label="序号" width="55"></el-table-column>
                    <el-table-column prop="labelName" label="标签名称"></el-table-column>
                    <el-table-column prop="skillNames" label="所需技能"></el-table-column>

                    <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>

                    <el-table-column label="操作" fixed="right" width="150">
                        <template slot-scope="scope">
                            <el-button type="text" v-per="'updateCourse'" icon="el-icon-edit"
                                @click="delLabel(scope.row)">删除标签</el-button>
                            <el-button type="text" v-per="'delCourse'" icon="el-icon-delete"
                                @click="updateLabel(scope.row)">修改标签</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页 -->
                <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
            </el-card>
        </div>

        <!--技能配置 -->
        <div  v-if="activeName=='skillconfig'">
            <el-card shadow="hover">

                <el-form :inline="true" size="small" v-model="listQuery2">

                    <el-form-item label="技能名称">
                        <el-input v-model="listQuery2.skillName" placeholder="" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="primary" plan @click="querySearch2">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" class="el-icon-plus" plan @click="addskillclick">新增技能</el-button>
                    </el-form-item>

                </el-form>

                <el-table :data="listData2" border style="width: 100%" class="table">
                    <el-table-column type="index" label="序号" width="55"></el-table-column>
                    <el-table-column prop="skillName" label="技能程名称"></el-table-column>
                    <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>

                    <el-table-column label="操作" fixed="right" width="150">
                        <template slot-scope="scope">
                            <el-button type="text" v-per="'updateCourse'" icon="el-icon-edit"
                                @click="delSkill( scope.row)">
                                删除技能</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <pagination :total="total2" :page.sync="currentPage2" :limit.sync="pageSize2"
                    @pagination="querySearch2" />
            </el-card>
        </div>

        <el-dialog title="添加技能" :visible.sync="addskillshow" width="400px" :close-on-click-modal="false" center>
            <el-form>
                <el-form-item label="技能名称" prop="addSkillName">
                    <el-input style="width:180px;" clearable v-model="addSkillName"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addskillshow = false">关闭</el-button>
                <el-button type="primary" @click="saveSkill()">提交</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="isupdate=='0'?'添加标签':'修改标签'" :visible.sync="addlabelshow" width="400px"
            :close-on-click-modal="false" center>
            <el-form>
                <el-form-item label="标签名称">
                    <el-input :readonly="isupdate==1" style="width:180px;" clearable v-model="labelDto.labelName">
                    </el-input>
                </el-form-item>
                <el-form-item label="对应技能">
                    <el-select v-model="labelDto.skillIds" clearable multiple placeholder="请选择技能" filterable>
                        <el-option v-for="(item,index) in skillList" :key="index" :label="item.skillName"
                            :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addlabelshow = false">关闭</el-button>
                <el-button type="primary" @click="saveLabel()">提交</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import crmApi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
let vm;
export default {
    components: { Pagination },
    data() {
        return {
            activeName: "labelconfig",
            addskillshow: false,
            addlabelshow: false,
            isupdate: 0, //修改标签
            skillList: [],

            listData: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                labelName: null,
            },
            labelDto: {
                id: null,
                labelName: null,
                skillIds: [],
                skillNames: null,
            },

            listData2: [],
            total2: 0,
            pageSize2: 10,
            currentPage2: 1, //当前页
            listQuery2: {
                skillName: null,
            },
            addSkillName: null,
        };
    },

    created() {
        this.getAllSkill();
        this.querySearch();
    },
    methods: {
        delLabel(row) {
            this.$confirm("是否确认删除标签?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    crmApi
                        .$axiosEmLableSkillDeleteLabelSkill({
                            id: row.id,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("操作成功");
                                this.querySearch();
                            }
                        });
                })
                .catch(() => { });
        },
        saveLabel() {
            if (
                this.labelDto.labelName == null ||
                this.labelDto.labelName == ""
            ) {
                this.$message.error("请输入标签名称");
                return;
            }
            if (this.labelDto.skillIds.length == 0) {
                this.$message.error("请选择对应技能");
                return;
            }
            let names = [];
            let that = this;
            that.labelDto.skillIds.forEach((d) => {
                this.skillList.forEach((e) => {
                    if (e.id == d) {
                        names.push(e.skillName);
                    }
                });
            });

            let req = {
                labelName: this.labelDto.labelName,
                skillIds: this.labelDto.skillIds.join(","),
                skillNames: names.join(","),
            };
            if (this.isupdate == 1) {
                req.id = this.labelDto.id;
            }
            crmApi.$axiosEmLableSkillAddLabelSkill(req).then((res) => {
                if (res.data.errno == 0) {
                    this.$message.success("新增成功");
                    this.addlabelshow = false;
                    this.querySearch();
                }
            });
        },
        updateLabel(row) {
            this.addlabelshow = true;
            this.isupdate = 1; //修改标签
            this.labelDto = {
                id: row.id,
                labelName: row.labelName,
                skillIds: row.skillIds.split(","),
                skillNames: row.skillNames,
            };
        },
        addLabelClick() {
            this.addlabelshow = true;
            this.isupdate = 0;
            this.labelDto = {
                id: null,
                labelName: null,
                skillIds: [],
                skillNames: null,
            };
        },
        saveSkill() {
            if (this.addSkillName == null || this.addSkillName == "") {
                this.$message.error("请输入技能名称");
                return;
            }
            crmApi
                .$axiosEmSkillAddSkill({
                    skillName: this.addSkillName,
                })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.$message.success("操作成功");
                        this.addskillshow = false;
                        this.querySearch2();
                    }
                });
        },
        addskillclick() {
            //添加技能
            this.addskillshow = true;
            this.addSkillName = null;
        },
        delSkill(row) {
            this.$confirm("是否确认删除技能?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    crmApi
                        .$axiosEmSkillDeleteSkill({
                            id: row.id,
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("操作成功");
                                this.querySearch2();
                            }
                        });
                })
                .catch(() => { });
        },
        querySearch() {
            //查询标签
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            crmApi.$axiosEmLableSkillGetPageList(this.listQuery).then((res) => {
                if (res.data.errno == 0) {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                }
            });
        },
        querySearch2() {
            //查询技能
            this.listQuery2.pageSize = this.pageSize2;
            this.listQuery2.pageNum = this.currentPage2;
            crmApi.$axiosEmSkillGetPageList(this.listQuery2).then((res) => {
                if (res.data.errno == 0) {
                    this.listData2 = res.data.data.list;
                    this.total2 = res.data.data.total;
                }
            });
        },
        getAllSkill() {
            crmApi.$ajaxEmCourseGetAllSkillDict().then((res) => {
                if (res.data.errno == 0) {
                    this.skillList = res.data.data;
                }
            });
        },
        handleClick(tab, event) {
            console.log(tab, event);
            if (tab.index == 1) {
                this.querySearch2();
            } else {
                this.querySearch();
            }
        },
    },
    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
   .mytab  {
        height: 50px;
    }
.crumbs {
    margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}

.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>